export function removeZeros(arr: number[]): number[] {
  return arr.filter((num) => num !== 0);
}
